var textarea = tokens => ({
  shape: {
    height: '104px'
  },
  focus: {
    padding: "".concat(tokens.spacingY['xl'], " 0 ").concat(tokens.spacingY['xl'], " ").concat(tokens.spacingX['5xl'])
  },
  placeholder: {
    top: tokens.spacingY['5xl'],
    active: {
      top: tokens.spacingY.xl
    }
  },
  value: {
    height: "calc(100% - ".concat(tokens.spacingY.xl, " - ").concat(tokens.lineHeight.xs, " - ").concat(tokens.spacingY.xl, ")")
  },
  counter: {
    marginLeft: tokens.spacingLeft['3xl']
  }
});
export default textarea;
//# sourceMappingURL=textarea.js.map